import splitButtonVariables from './splitButtonVariables';

export default splitButtonVariables;
